export const columnsSort = <T>(items: T[], columns: number): T[] => {
    const itemsPerColumn = Math.ceil(items.length / columns);

    const columnValues: T[][] = Array.from({ length: columns }, () => []);
    for (let i = 0; i < columns; i += 1) {
        columnValues[i] = items.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn);
    }

    const rowValues: T[] = [];
    for (let i = 0; i < itemsPerColumn; i += 1) {
        for (let j = 0; j < columns; j += 1) {
            if (columnValues[j][i]) {
                rowValues.push(columnValues[j][i]);
            }
        }
    }

    return rowValues;
};
